import titles from "@/store/lang/titles.json";
import { mapActions, mapState, mapGetters } from "vuex";
import Success from "../success/Success.vue";
import Tooltip from "../tooltip/tooltip.vue";
import InvisibleRecaptcha from "vue-invisible-recaptcha";
export default {
  name: "RentalPickup",
  components: {
    Success,
    Tooltip,
    InvisibleRecaptcha,
  },
  data() {
    return {
      e1: 1,
      rentalPickupTitles: titles.rentalPickupTitles,
      rulesTitle: titles.rulesTitle.rentalPickup,
      hoverContactName: false,
      hoverPhone: false,
      hoverUnit: false,
      hoverCondition: false,
      hoverOtherInfo: false,
      panelOpen: 1,
      isRentalPickupValid: false,
      isRentalPickupRequirementValid: false,
      isRentalPickupInfoValid: false,
      isRentalTick: false,
      isRentalRequirementTick: false,
      isRentalInfoTick: false,
      rules: {
        nameRules: [(v) => !!v || titles.rulesTitle.rentalPickup.name],
        emailRules: [
          (v) => !!v || titles.rulesTitle.rentalPickup.email,
          (v) => /.+@.+/.test(v) || titles.rulesTitle.rentalPickup.email,
        ],
        addressRules: [(v) => !!v || titles.rulesTitle.rentalPickup.address],
        sitePhoneNumberRules: [
          (v) => !!v || titles.rulesTitle.rentalPickup.siteContactPhone,
          function(v) {
            if (v) {
              let value = v.replace(/\D/g, "");
              return (
                (!isNaN(parseFloat(value)) && value.length == 10) ||
                titles.rulesTitle.rentalPickup.siteContactPhone
              );
            }
            return titles.rulesTitle.rentalPickup.siteContactPhone;
          },
        ],
      },
      requestForm: {
        event_type: "rental_pickup_request",
        firstname: null,
        lastname: null,
        email: null,
        address: {
          street: null,
          city: null,
          state: null,
          zipCode: null,
        },
        site_info: {
          name: null,
          phone: null,
        },
        unit_number: null,
        pre_req: {
          isAccessible: false,
          isEmpty: false,
          isNotLocked: false,
        },
        additional_info: null,
        CountryCode: "",
      },
      isSubmitSuccessful: false,
      isLoading: false,
      activeStep: 1,
      animation: "animate-in",
      isSubmitting: false,
    };
  },
  computed: {
    ...mapState("app", ["globalTheme"]),
    ...mapGetters(["getCountryCode"]),
    requirementRules() {
      return [
        this.requestForm.pre_req.isAccessible == true ||
          titles.rulesTitle.rentalPickup.requirements,
        this.requestForm.pre_req.isEmpty == true ||
          titles.rulesTitle.rentalPickup.requirements,
        this.requestForm.pre_req.isNotLocked == true ||
          titles.rulesTitle.rentalPickup.requirements,
          
      ];
    },
    progress(){
      return (this.activeStep-1)/2 *100

    },
  },
  methods: {
    ...mapActions(["addFormRequest"]),
    validateRentalPickupField() {
      this.isRentalPickupValid = this.$refs.rentalPickupForm.validate();
      this.isRentalTick = this.isRentalPickupValid;
      this.$refs.rentalPickupForm.validate();
    },
    validateRentalPickupRequirementField() {
      this.isRentalPickupRequirementValid =
        this.requestForm.pre_req.isAccessible &&
        this.requestForm.pre_req.isEmpty &&
        this.requestForm.pre_req.isNotLocked
          ? true
          : false;
      this.isRentalRequirementTick = this.isRentalPickupRequirementValid;
      this.$refs.rentalPickupRequirementForm.validate();
    },
    getPriorPanel(event, idx) {
      event ? event.preventDefault() : null;
      switch (idx) {
        case 2:
          this.priorStep();
          break;
        case 3:
          this.priorStep();
          break;
      }
    },
    getNextPanel(event, idx) {
      event ? event.preventDefault() : null;
      switch (idx) {
        case 1:
          this.validateRentalPickupField();
          !this.isRentalPickupValid ? this.notValid() : this.nextStep();
          break;
        case 2:
          this.validateRentalPickupRequirementField();
          !this.isRentalPickupRequirementValid
            ? this.notValid()
            : this.nextStep();
          break;
      }
    },
    submit() {
      this.isLoading = true;
      this.requestForm.CountryCode = this.getCountryCode;
      this.isSubmitting = true;
      if (this.isRentalPickupInfoValid) {
        this.panelOpen = null;
        this.addFormRequest({
          data: this.requestForm,
          event_type: this.requestForm.event_type,
        })
          .then((response) => {
            if (
              response &&
              response.data &&
              response.data.ResponseMetadata &&
              response.data.ResponseMetadata.HTTPStatusCode == 200
            ) {
              this.isSubmitSuccessful = true;
              this.isLoading = false;
            }
            this.isSubmitting = false;
          })
          .catch((err) => {
            console.log(err);
            this.isSubmitting = false;
          });
      }
    },
    getRequestForm() {
      this.requestForm = {
        event_type: "rental_pickup_request",
        firstname: null,
        lastname: null,
        email: null,
        address: {
          street: null,
          city: null,
          state: null,
          zipCode: null,
        },
        site_info: {
          name: null,
          phone: null,
        },
        unit_number: null,
        pre_req: {
          isAccessible: false,
          isEmpty: false,
          isNotLocked: false,
        },
        additional_info: null,
        CountryCode: this.getCountryCode,
      };
      this.isSubmitSuccessful = false;
      this.activeStep = 1;
      this.isRentalTick = false;
      this.isRentalRequirementTick = false;
      this.isRentalInfoTick = false;
    },
    priorStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep -= 1;
      }, 600);
    },
    nextStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep += 1;
      }, 600);
    },
    notValid() {
      this.animation = "animate-wrong";
      setTimeout(() => {
        this.animation = "";
      }, 400);
    },
    getStepperContent(step) {
      this.activeStep = step;
      switch (step) {
        case 1:
          this.isRentalTick = false;
          break;
        case 2:
          this.isRentalRequirementTick = false;
          break;
        case 3:
          this.isRentalInfoTick = false;
          break;
      }
    },

    isAllValid() {
      return (
        !(this.isRentalTick && this.isRentalRequirementTick) ||
        this.isSubmitting
      );
    },

    /*isAllValid() {
      return this.isRentalTick && this.isRentalRequirementTick;
    },*/

    submitted(response) {
      /*resposne will have the reCAPTCHA token.
      If token is null or empty do nothing.*/
      if (!response) return;
      this.submit();
    },
  },
};
